<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" dark v-bind="attrs" v-on="on"> Create Company </v-btn>
    </template>

    <v-card>
      <v-card-title class="text-h5 primary white--text"> Create Company </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-text-field v-model="companyName" label="Company Name" :rules="[rules.required]">
          </v-text-field>

          <div class="text-subtitle-2">Invite company administrators</div>
          <v-row class="my-1" dense v-for="(email, index) in inviteEmails" :key="index">
            <v-col cols="9">
              <v-text-field
                dense
                :ref="`textfield-${index}`"
                @keyup.enter.native="tryAdd(index)"
                :hide-details="index != 0"
                @paste="onPaste(index)"
                v-model="inviteEmails[index]"
                :placeholder="$t('common.email')"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <div class="d-flex">
                <v-btn
                  v-if="inviteEmails.length > 1"
                  icon
                  small
                  color="primary"
                  class="ml-3"
                  @click="inviteEmails.splice(index, 1)"
                >
                  <v-icon>mdi-minus-circle-outline</v-icon>
                </v-btn>
                <v-btn
                  v-if="index == inviteEmails.length - 1 && index < 9"
                  icon
                  small
                  color="primary"
                  @click="addEmail"
                  class="ml-3"
                >
                  <v-icon>mdi-plus-circle-outline</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-checkbox
            v-model="whitelistDomain"
            :label="`Let any one with @${emailDomain} email to join this workspace`"
          ></v-checkbox>
        </v-form>
        <span class="grey--text text-caption"
          >You will be able to further customize your company branding in your company
          settings</span
        >
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" :loading="loading" @click="createCompany()"> Create</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import functions from "@/firebase/functions";

export default {
  data() {
    return {
      dialog: false,
      whitelistDomain: true,
      inviteEmails: [""],
      loading: false,
      companyName: "",
      companyId: null,
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  computed: {
    emailDomain() {
      return this.$store.state.firUser.email.split("@").pop();
    },
    company() {
      return this.companyId ? this.$store.state.companies[this.companyId] : null;
    },
  },
  watch: {
    company(newVal) {
      console.log("company updated", newVal);
      if (newVal) {
        console.log("pushing");
        this.$router.push({ name: "Trips" });
        this.loading = false;
        this.dialog = false;
      }
    },
  },
  methods: {
    onPaste(index) {
      console.log(`index is : ${index}`);

      setTimeout(() => {
        console.log(`index is : ${index}`);
        const emails = this.inviteEmails[index];
        console.log(emails);
        const splitEmails = (emailArr) => {
          this.inviteEmails[index] = emailArr.shift();

          emailArr.forEach((email) => {
            if (email !== "") {
              this.inviteEmails.push(email);
            }
          });
        };

        if (emails.includes(",")) {
          const emailArr = emails.replace(/ /gi, "").split(",");
          splitEmails(emailArr);
        } else if (emails.includes(";")) {
          const emailArr = emails.replace(/ /gi, "").split(";");
          splitEmails(emailArr);
        }
      }, 50);
    },
    tryAdd(index) {
      if (index === this.inviteEmails.length - 1) {
        this.addEmail();
      }
    },
    addEmail() {
      this.inviteEmails.push("");
      const ref = `textfield-${this.inviteEmails.length - 1}`;
      setTimeout(() => {
        this.$refs[ref][0].focus();
      }, 50);
    },
    async createCompany() {
      if (!this.$refs.form.validate()) {
        console.log("form not valid");
        return;
      }
      const emails = this.inviteEmails.filter((e) => e !== "").map((m) => m.toLowerCase());
      console.log("sending invites to ", emails);
      this.loading = true;
      try {
        const response = await functions.createCompany({
          companyName: this.companyName,
          invites: emails,
          companyDomain: this.whitelistDomain ? this.emailDomain : null,
        });
        this.companyId = response.data;
        console.log("created company with id", this.companyId);
        await this.$store.dispatch("getCompany", this.companyId);
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
  },
};
</script>
